// third-party
import {merge} from 'lodash';

// project import
import Accordion from './accordion';
import AccordionDetails from './accordionDetails';
import AccordionSummary from './accordionSummary';
import Alert from './alert';
import AlertTitle from './alertTitle';
import Autocomplete from './autocomplete';
import Badge from './badge';
import Button from './button';
import ButtonBase from './buttonBase';
import ButtonGroup from './buttonGroup';
import CardContent from './cardContent';
import Checkbox from './checkbox';
import Chip from './chip';
import Dialog from './dialog';
import DialogContentText from './dialogContentText';
import DialogTitle from './dialogTitle';
import Fab from './fab';
import IconButton from './iconButton';
import InputBase from './inputBase';
import InputLabel from './inputLabel';
import LinearProgress from './linearProgress';
import Link from './link';
import ListItemButton from './listItemButton';
import ListItemIcon from './listItemIcon';
import LoadingButton from './loadingButton';
import OutlinedInput from './outlinedInput';
import Pagination from './pagination';
import PaginationItem from './paginationItem';
import Popover from './popover';
import Radio from './radio';
import Slider from './slider';
import Switch from './switch';
import Tab from './tab';
import TableBody from './tableBody';
import TableCell from './tableCell';
import TableFooter from './tableFooter';
import TableHead from './tableHead';
import TablePagination from './tablePagination';
import TableRow from './tableRow';
import Tabs from './tabs';
import ToggleButton from './toggleButton';
import Tooltip from './tooltip';
import TreeItem from './treeItem';
import Typography from './typography';
import Drawer from "./drawer";
import DataGrid from "./dataGrid";
import FormLabel from "./formLabel";

// ==============================|| OVERRIDES - MAIN ||============================== //

export default function ComponentsOverrides(theme) {
    return merge(
        Accordion(theme),
        AccordionDetails(theme),
        AccordionSummary(theme),
        Alert(theme),
        AlertTitle(),
        Autocomplete(),
        Badge(theme),
        Button(theme),
        ButtonBase(),
        ButtonGroup(),
        CardContent(),
        Checkbox(theme),
        Chip(theme),
        DataGrid(theme),
        Dialog(),
        DialogContentText(theme),
        DialogTitle(),
        Drawer(theme),
        Fab(theme),
        FormLabel(theme),
        IconButton(theme),
        InputBase(),
        InputLabel(theme),
        LinearProgress(),
        Link(),
        ListItemButton(theme),
        ListItemIcon(theme),
        LoadingButton(),
        OutlinedInput(theme),
        Pagination(),
        PaginationItem(theme),
        Popover(theme),
        Radio(theme),
        Slider(theme),
        Switch(theme),
        Tab(theme),
        TableBody(theme),
        TableCell(theme),
        TableFooter(theme),
        TableHead(theme),
        TablePagination(),
        TableRow(),
        Tabs(),
        ToggleButton(theme),
        Tooltip(theme),
        TreeItem(),
        Typography()
    );
}
